<template>
    <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M8 0H0v8h8V0Z" fill="#DBDBDB" />
        <path d="M18 0h-8v8h8V0Z" fill="#BDBDBD" />
        <path d="M8 10H0v8h8v-8Z" fill="#CFCFCF" />
        <path d="M18 10h-8v8h8v-8Z" fill="#D6D6D6" />
    </svg>
</template>
